<div class="signup-page-wrapper">
  <div class="signup-container">
    <div class="signup-header">
      <div class="logo-section">
        <img src="assets/deeproots-logo.jpg" alt="App Logo" class="app-logo" />
      </div>

      @if (isLoading) {
        <div class="loading-state">
          <div class="spinner-container">
            <svg class="spinner" width="40" height="40" viewBox="0 0 24 24">
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
                fill="none"
                stroke-dasharray="32"
                stroke-dashoffset="32"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  values="32;0"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </div>
          <p class="loading-text">Validating your invitation...</p>
        </div>
      }

      @if (!isLoading && errorMessage) {
        <div class="error-state">
          <div class="error-icon-large">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <h1 class="error-title">Invitation Invalid</h1>
          <p class="error-description">{{ errorMessage }}</p>
          <a routerLink="/login" class="back-link">Go to Login</a>
        </div>
      }

      @if (!isLoading && isValid) {
        <h1 class="signup-title">Welcome!</h1>
        <p class="signup-subtitle">
          To complete your organization's onboarding, please log in with your
          preferred secure identity provider.
        </p>

        <div class="login-buttons">
          <button
            type="button"
            class="login-button btn-microsoft"
            (click)="loginWithMicrosoft()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
            >
              <title>MS-SymbolLockup</title>
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            <span>Continue with Microsoft</span>
          </button>

          <button
            type="button"
            class="login-button btn-google"
            (click)="loginWithGoogle()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            <span>Continue with Google</span>
          </button>
        </div>
      }
    </div>

    <div class="signup-footer">
      <p>
        Already have an account?
        <a routerLink="/login" class="login-link">Sign in here</a>
      </p>
    </div>
  </div>
</div>
